import Vue from "vue";
import Vuex from "vuex";
import api from "api";

var firstBy = require('thenby');

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    notes: [],
    tasks: [],
    project_areas: [],
    active_tags: [],
    archived_tags: [],
    events: [],
    archived_projects: [],
    current_project: {},
    current_tag_name: '',
    active_contacts: [],
    archived_contacts: [],
    sorted_groups: []
  },
  getters: {
    currentProject(state){
      return state.current_project;
    },
    currentTagName(state){
      return state.current_tag_name;
    },
    activeContactIds(state){
      return state.active_contacts.map(contact => contact.id)
    },
    activeTagIds(state){
      return state.active_tags.map(tag => tag.id)
    },
    sortedActiveContacts(state){
      var ids = state.sorted_groups.contacts
      if(ids !== undefined){
        var order = {}

        ids.forEach(function (a, i) { order[a] = i; });

        return state.active_contacts.sort(function (a, b) {
            return order[a.id] - order[b.id];
        });
      } else {
        return state.active_contacts
      }
    },
    sortedArchivedContacts(state){
      var ids = state.sorted_groups.archived_contacts
      if(ids !== undefined){
        var order = {}

        ids.forEach(function (a, i) { order[a] = i; });

        return state.archived_contacts.sort(function (a, b) {
            return order[a.id] - order[b.id];
        });
      } else {
        return state.archived_contacts
      }
    },
    sortedActiveTags(state){
      var ids = state.sorted_groups.tags
      if(ids !== undefined){
        var order = {}

        ids.forEach(function (a, i) { order[a] = i; });

        return state.active_tags.sort(function (a, b) {
            return order[a.id] - order[b.id];
        });
      } else {
        return state.active_tags
      }
    },
    sortedArchivedTags(state){
      var ids = state.sorted_groups.archived_tags
      if(ids !== undefined){
        var order = {}

        ids.forEach(function (a, i) { order[a] = i; });

        return state.archived_tags.sort(function (a, b) {
            return order[a.id] - order[b.id];
        });
      } else {
        return state.archived_tags
      }
    },
    tier1Tasks(state){
      return function (tier1, hideComletedTasks){
        var tier1Name = tier1
        var tasks = state.tasks.filter(function (task){
          return (task.tier1 == tier1Name)
        })

        if (hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
  
        return tasks
      }
    },
    sortedTier1Tasks(state, getters){
      return function (tier1, hideComletedTasks = true){
        var ids = state.sorted_groups['tier1' + tier1]
        if(ids !== undefined){
          var order = {}

          ids.forEach(function (a, i) { order[a] = i; });

          return getters.tier1Tasks(tier1, hideComletedTasks).sort(function (a, b) {
              return order[a.id] - order[b.id];
          });
        } else {
          return getters.tier1Tasks(tier1, hideComletedTasks)
        }
      }
    },
    todayTasks(state){
      return function (hideComletedTasks){

        var tasks = state.tasks.filter(function (task){
          return (task.due_date <= new Date().toISOString().split('T')[0]);
        })

        if (hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
  
        return tasks
      }
    },    
    sortedTodayTasks(state, getters){
      return function (hideComletedTasks = true){
        var ids = state.sorted_groups['today']
        if(ids !== undefined){
          var order = {}

          ids.forEach(function (a, i) { order[a] = i; });

          return getters.todayTasks(hideComletedTasks).sort(function (a, b) {
              return order[a.id] - order[b.id];
          });
        } else {
          return getters.todayTasks(hideComletedTasks)
        }
      }
    },
    projectTasks(state){
      return function (projectId, hideComletedTasks){
        var projectId = projectId
        var tasks = state.tasks.filter(function (task){
          return (task.project_id === projectId)
        })

        if (hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
  
        return tasks
      }
    },
    sortedProjectTasks(state, getters){
      return function (projectId, hideComletedTasks = true){
        var ids = state.sorted_groups['projectId' + projectId]
        if(ids !== undefined){
          var order = {}

          ids.forEach(function (a, i) { order[a] = i; });

          return getters.projectTasks(projectId, hideComletedTasks).sort(function (a, b) {
              return order[a.id] - order[b.id];
          });
        } else {
          return getters.projectTasks(projectId, hideComletedTasks)
        }
      }
    },
    tagTasks(state){
      return function (tagName, hideComletedTasks){
        state.current_tag_name = tagName

        var tasks = state.tasks.filter(function (task){
          var tag_list = task.tags.map(t => t.name);
          return (tag_list.includes(tagName));
        })

        if (hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
  
        return tasks
      }
    },
    sortedTagTasks(state, getters){
      return function (tagSlug, hideComletedTasks = true){
        var tagName = tagSlug.replace(/_/g, ' ');

        var ids = state.sorted_groups['tagName' + tagName]
        if(ids !== undefined){
          var order = {}

          ids.forEach(function (a, i) { order[a] = i; });

          return getters.tagTasks(tagName, hideComletedTasks).sort(function (a, b) {
              return order[a.id] - order[b.id];
          });
        } else {
          return getters.tagTasks(tagName, hideComletedTasks)
        }
      }
    },
    contactTasks(state){
      return function (contactId, hideComletedTasks){
        var contactId = contactId
        var tasks = state.tasks.filter(function (task){
          return (task.formatted_contact_list.includes(contactId))
        })

        if (hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
  
        return tasks
      }
    },
    sortedContactTasks(state, getters){
      return function (contactId, hideComletedTasks = true){

        var ids = state.sorted_groups['contactId' + contactId]
        if(ids !== undefined){
          var order = {}

          ids.forEach(function (a, i) { order[a] = i; });

          return getters.contactTasks(contactId, hideComletedTasks).sort(function (a, b) {
              return order[a.id] - order[b.id];
          });
        } else {
          return getters.contactTasks(contactId, hideComletedTasks)
        }
      }
    },    
  },
  mutations: {
    addNote(state, data){
      state.notes.unshift(data)
    },
    deleteNote(state, note){
      var index = state.notes.findIndex(n => n.id === note.id);
      state.notes.splice(index, 1);
    },
    updateNote(state, note){
      var index = state.notes.findIndex(n => n.id === note.id);
      state.notes.splice(index, 1, note);
    },
    addTask(state, data){
      state.tasks.unshift(data)
    },
    deleteTask(state, task){
      var index = state.tasks.findIndex(t => t.id === task.id);
      state.tasks.splice(index, 1);
    },
    updateTask(state, task){
      var index = state.tasks.findIndex(t => t.id === task.id);
      state.tasks.splice(index, 1, task);

      if(task.sort === null){
        state.tasks.sort(
          firstBy(function (t) { return t.completed_at == null }, -1)
          .thenBy("completed_at", -1)
          .thenBy("created_at", -1)
        );
      } else {
        state.tasks.sort(firstBy("sort"));
      }
    },
    updateActiveTags(state, tags){
      state.active_tags = tags;
    },
    updateArchivedTags(state, tags){
      state.archived_tags = tags;
    },
    updateAllTasks(state){
      api.getTasks().then(response => {
        state.tasks = response.data;
      });
    },
    addProject(state, data){
      var project_area_index = state.project_areas.findIndex(a => a.id === data.project_area.id);
      state.project_areas[project_area_index].projects.push(data)
    },
    deleteProject(state, project){
      var project_area_index = state.project_areas.findIndex(a => a.id === project.project_area.id);
      var project_index = state.project_areas[project_area_index].projects.findIndex(p => p.id === project.id);
      state.project_areas[project_area_index].projects.splice(project_index, 1);

      state.archived_projects.unshift(project)
    },
    undeleteProject(state, project){
      var project_index = state.archived_projects.findIndex(p => p.id === project.id);
      state.archived_projects.splice(project_index, 1);
    },
    updateProject(state, project){
      var project_area_index = state.project_areas.findIndex(a => a.id === project.project_area.id);
      var project_index = state.project_areas[project_area_index].projects.findIndex(p => p.id === project.id);
      state.project_areas[project_area_index].projects.splice(project_index, 1, project);

      api.getProjectAreas().then(response => {
        state.project_areas = response.data;
      });
    },
    addProjectArea(state, data){
      var new_data = data.project_area
      new_data.projects = []
      state.project_areas.push(new_data)
    },
    deleteProjectArea(state, project_area){
      var project_area_index = state.project_areas.findIndex(a => a.id === project_area.id);
      state.project_areas.splice(project_area_index, 1);
    },
    updateProjectArea(state, project_area_data){
       var project_area_index = state.project_areas.findIndex(a => a.id === project_area_data.id);
      var areaProjects = state.project_areas[project_area_index].projects
      state.project_areas[project_area_index] = project_area_data
      state.project_areas[project_area_index].projects = areaProjects

      api.getProjectAreas().then(response => {
        state.project_areas = response.data;
      });
    },
    updateActiveContacts(state, data){
      state.active_contacts = data
    },
    updateArchivedContacts(state, data){
      state.archived_contacts = data
    },
    // payload should contain name and ordered_ids
    updateSortedGroup(state, payload){
      var name = payload.name
      var ordered_ids = payload.ordered_ids

      state.sorted_groups[name] = ordered_ids
      api.updateSortedGroup(name, ordered_ids)
    },
    // payload should contain name and id
    addIdToSortedGroup(state, payload){
      var name = payload.name
      var id = payload.id

      var ordered_ids = state.sorted_groups[name]
      ordered_ids.unshift(id)

      state.sorted_groups[name] = ordered_ids
      api.updateSortedGroup(name, ordered_ids)
    },
    // payload should contain name and id
    removeIdFromSortedGroup(state, payload){
      var name = payload.name
      var id = payload.id

      var ordered_ids = state.sorted_groups[name]

      ordered_ids = ordered_ids.filter(function(item) {
        return item !== id
      })

      state.sorted_groups[name] = ordered_ids
      api.updateSortedGroup(name, ordered_ids)
    },
    // payload is taskId and groupName
    addToSortedGroup(state, payload) {
      var taskId = payload.taskId
      var groupName = payload.groupName

      api.getSortedGroup(groupName).then(response => {
        var ordered_ids = response.data.ordered_ids
        
        if(ordered_ids !== null){
          ordered_ids = ordered_ids.filter(function(x) {
            return x !== taskId;
          })

          ordered_ids.unshift(taskId);

          api.updateSortedGroup(groupName, ordered_ids).then(response => {
            state.sorted_groups[groupName] = ordered_ids
          })
        }
      })
    },
    // payload is taskId and groupName
    removeFromSortedGroup(state, payload) {
      var taskId = payload.taskId
      var groupName = payload.groupName

      api.getSortedGroup(groupName).then(response => {
        var ordered_ids = response.data.ordered_ids
        
        if(ordered_ids !== null){
          ordered_ids = ordered_ids.filter(function(x) {
            return x !== taskId;
          })

          api.updateSortedGroup(groupName, ordered_ids).then(response => {
            state.sorted_groups[groupName] = ordered_ids
          })
        }
      })
    },
  }
});
